module.exports = {"Atelier":"Atelier","Projets":"Projets","Equipe":"Equipe","Contact":"Contact","Editeur":"Éditeur","sarl":"Sàrl","sa":"sa","plan-daccès":"Plan d'accès","voir-le-projet":"Voir le projet","suivant":"suivant","précédent":"précédent","retour":"tous","Mail":"Email","Phone":"Téléphone","video-title":"AAS Architecture SA : l’architecture comme un art du sur-mesure.","video-desc":"Un regard signé Le Figaro sur une pratique exigeante, attentive aux usages, aux matériaux et aux lieux.","video-link":"Lien vers l'article complet"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/translations/fr.json
// module id = fds+
// module chunks = 1